import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var urlG = process.env.API_URL;

const state = {
  termsVerified: false,
  searchResultsList: [],
  targetResultsList: [],
  probesResultsList: [],
  probesResultsListCustom: [],
  compoundResultsList: [],
  compound2ResultsList: [],
  probeGeneName: null,
  portalList: null,
  loading: false,
  urlG: urlG
}

const getters = {
  termsVerified: state => state.termsVerified,
  searchResultsList: state => state.searchResultsList,
  targetResultsList: state => state.targetResultsList,
  probesResultsList: state => state.probesResultsList,
  probesResultsListCustom: state => state.probesResultsListCustom,
  compoundResultsList: state => state.compoundResultsList,
  compound2ResultsList: state => state.compound2ResultsList,
  probeGeneName: state => state.probeGeneName,
  portalList: state => state.portalList,
  loading: state => state.loading
}

const mutations = {
  VERIFY_TERMS: (state) => {
    state.termsVerified = true
  },
  SET_SEARCH_LIST: (state, {
    data
  }) => {
    let a = [];
    data.map(function(m, i) {
      a.push({
        name: m[0],
        uni: m[2],
        is_suitable_probe: m[3][0] === '0' ? 0 : m[3].substring(0, m[3].indexOf("|")),
        is_selectivity: m[4][0] === '0' ? 0 : m[4].substring(0, m[4].indexOf("|")),
        is_target_potency: m[5][0] === '0' ? 0 : m[5].substring(0, m[5].indexOf("|")),
        is_cell_potency: m[6][0] === '0' ? 0 : m[6].substring(0, m[6].indexOf("|")),
        is_sar: m[7][0] === '0' ? 0 : m[7].substring(0, m[7].indexOf("|")),
        is_inactive_analogs: m[8][0] === '0' ? 0 : m[8].substring(0, m[8].indexOf("|")),
        is_pains: m[9][0] === '0' ? 0 : m[9].substring(0, m[9].indexOf("|")),
        compounds: m[10],
        score: m[11]
      })
    })
    state.searchResultsList = a;
  },
  SET_TARGET_BY_ID: (state, {
    data
  }) => {
    let a = [];

    if (data) {

      data.map(function(m, i) {
        a.push({
          name: m[0],
          uni: m[2],
          is_suitable_probe: m[3][0] === '0' ? 0 : m[3].substring(0, m[3].indexOf("|")),
          is_selectivity: m[4][0] === '0' ? 0 : m[4].substring(0, m[4].indexOf("|")),
          is_target_potency: m[5][0] === '0' ? 0 : m[5].substring(0, m[5].indexOf("|")),
          is_cell_potency: m[6][0] === '0' ? 0 : m[6].substring(0, m[6].indexOf("|")),
          is_sar: m[7][0] === '0' ? 0 : m[7].substring(0, m[7].indexOf("|")),
          is_inactive_analogs: m[8][0] === '0' ? 0 : m[8].substring(0, m[8].indexOf("|")),
          is_pains: m[9][0] === '0' ? 0 : m[9].substring(0, m[9].indexOf("|")),
          compounds: m[10],
          score: m[11]
        })
      })
    }

    state.targetResultsList = a.length ? a[0] : null;
  },
  SET_TARGET_PROBES_BY_ID: (state, {
    data
  }) => {
    if (data.data !== null) {
      state.probesResultsList = data.tabs_info.tab1;
      state.probeGeneName = data.gene_name;
      state.portalList = data.probe_portal || null;
    } else if (data.data === null) {
      state.probesResultsList = null
      state.probeGeneName = null
      state.portalList = null
    }

  },
  SET_TARGET_PROBES_BY_ID_AND_CUSTOM_FILTERS: (state, {
    data
  }) => {
    state.probesResultsListCustom = data.tabs_info.tab1;
  },
  SET_COMPOUND_BY_ID: (state, {
    data
  }) => {
    if (data && data.data && data.data_compound) {
      state.compoundResultsList = data;
      state.probeGeneName = data.gene_name;
    } else {
      state.compoundResultsList = null;
      state.probeGeneName = null;
    }
  },
  SET_COMPOUND2_BY_ID: (state, {
    data
  }) => {
    if (!data) {
      state.compound2ResultsList = null;
    } else {
      state.compound2ResultsList = data;
    }

  },
  SET_LOADING: (state) => {
    state.loading = true;
  },
  UNSET_LOADING: (state) => {
    state.loading = false;
  }
}

// actions
const actions = {
  VERIFY_TERMS: function({
    commit
  }) {
    commit('VERIFY_TERMS')
  },
  SET_LOADING: function({
    commit
  }) {
    commit('SET_LOADING')
  },
  UNSET_LOADING: function({
    commit
  }) {
    commit('UNSET_LOADING')
  },
  GET_SEARCH_RESULTS: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/shared/ajax/all_ajax_calls_in_one_place.php?cmd=get_table_data&key=" + t + "&query=protein_keyword_search";

      axios.get(url).then((response) => {
        commit('SET_SEARCH_LIST', {
          data: response.data.data
        })
        resolve()
      }, (err) => {
        console.log(err);
      })
    })
  },
  GET_TARGET_RESULTS_BY_ID: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/shared/ajax/all_ajax_calls_in_one_place.php?cmd=get_table_data&key=" + t + "&query=protein_keyword_search";

      axios.get(url).then((response) => {

        if (response.data.data.length === 1 && response.data.data[0][2] === t) {
          commit('SET_TARGET_BY_ID', {
            data: response.data.data
          })
        } else {
          commit('SET_TARGET_BY_ID', {
            data: null
          })
        }
        resolve()
      }, (err) => {
        console.log(err);
      })
    })
  },
  GET_TARGET_PROBES_RESULTS_BY_ID: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t;
      axios.get(url).then((response) => {

        commit('SET_TARGET_PROBES_BY_ID', {
          data: response.data
        });
        resolve()
      }, (err) => {
        commit('SET_TARGET_PROBES_BY_ID', {
          data: {
            data: null
          }
        });
        resolve()
        console.log(err);
      })
    })
  },
  GET_TARGET_PROBES_RESULTS_BY_ID_AND_CUSTOM_FILTERS: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t.id +
        "&cell_potency=" + t.filters.cell_potency +
        "&target_potency=" + t.filters.target_potency +
        "&sar=" + t.filters.sar +
        "&selectivity=" + t.filters.selectivity +
        "&pains=" + t.filters.pains +
        "&inactive_analogs=" + t.filters.inactive_analogs;

      axios.get(url).then((response) => {

        commit('SET_TARGET_PROBES_BY_ID_AND_CUSTOM_FILTERS', {
          data: response.data
        });
        resolve()
      }, (err) => {
        console.log(err);
      })
    })
  },
  GET_COMPOUND_RESULTS_BY_ID: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t.id + "&compound_id=" + t.compound;

      axios.get(url).then((response) => {
        commit('SET_COMPOUND_BY_ID', {
          data: response.data
        });
        resolve()
      }, (err) => {
        commit('SET_COMPOUND_BY_ID', {
          data: null
        });
        resolve()
        console.log(err);
      })
    })
  },
  GET_COMPOUND2_RESULTS_BY_ID: function({
    commit
  }, t) {

    return new Promise((resolve, reject) => {

      let url = urlG + "/api.php?action=get_compound_info&compound_id=" + t;

      axios.get(url).then((response) => {

        commit('SET_COMPOUND2_BY_ID', {
          data: response.data
        });
        resolve()
      }, (err) => {

        commit('SET_COMPOUND2_BY_ID', {
          data: null
        });
        resolve()
        console.log(err);
      })
    })
  }

}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store.js